const STEPS = [
  { key: "ordered", label: "Ordered" },
  { key: "printing", label: "Printing" },
  { key: "embroidery", label: "Embroidery" },
  { key: "qc", label: "QC" },
  { key: "dispatched", label: "Dispatched" },
  { key: "delivered", label: "Delivered" },
];

export default function OrderPipeline({ status }) {
  const current = status === "cancelled" ? -1 : STEPS.findIndex((s) => s.key === status);
  return (
    <div data-testid="order-pipeline">
      {status === "cancelled" && (
        <p className="font-mono text-xs uppercase tracking-widest text-red-500 mb-4" data-testid="order-cancelled-label">Order cancelled</p>
      )}
      <div className="flex items-center">
        {STEPS.map((s, i) => {
          const done = current >= 0 && i <= current;
          const active = i === current;
          return (
            <div key={s.key} className="flex items-center flex-1 last:flex-none">
              <div className="flex flex-col items-center">
                <div
                  data-testid={`pipeline-step-${s.key}`}
                  className={`w-3.5 h-3.5 rotate-45 border-2 transition-colors ${
                    done ? (active ? "bg-kinetic border-kinetic" : "bg-zinc-300 border-zinc-300") : "border-zinc-700"
                  }`}
                />
                <span className={`mt-2 font-mono text-[9px] uppercase tracking-widest whitespace-nowrap ${done ? "text-zinc-200" : "text-zinc-600"}`}>
                  {s.label}
                </span>
              </div>
              {i < STEPS.length - 1 && <div className={`h-px flex-1 mx-1 mb-5 ${i < current ? "bg-kinetic" : "bg-zinc-800"}`} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
